import {
    AddCircle,
    CheckCircle,
    Clear,
    Delete,
    Description,
    Download,
    Edit,
    Grading,
    Search,
    Upload,
    Task,
} from "@mui/icons-material";
import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import { GridActionsCellItem, GridRowId, GridRowModel, GridSortDirection, GridSortModel } from "@mui/x-data-grid";
import { useEffect, useMemo, useState } from "react";

import AutoComplete from "../../../components/hookForms/autoComplete";
import { Button } from "@mui/material";
import ConfirmationDialog from "@/components/confirmationDialog";
import { Container } from "../../../theme/globalStyles";
import DataTable from "../../../components/dataTable";
import DatePickerMui from "../../../components/hookForms/datePicker";
import DialogApprove from "./modal/dialogApprove";
import DialogEdit from "./modal/dialogEdit";
import DialogLoad from "./modal/dialogLoad";
import DialogNew from "./modal/dialogNew";
import IGenericResult from "../../../interfaces/IGenericResult";
import Tooltip from "@mui/material/Tooltip";
import { format } from "date-fns";
import messages from "../../../utils/messages";
import { s3download } from "../../../utils/s3";
import serviceConcessionaria from "../../../services/serviceConcessionaria";
import serviceFaturaUsina from "../../../services/serviceFaturaUsina";
import serviceUsina from "../../../services/serviceUsina";
import { toast } from "react-toastify";
import useThrowAsyncError from "@/hooks/useThrowAsyncError";
/* eslint-disable react-hooks/exhaustive-deps */
import { useAuth } from "../../../context/global";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";

const FaturaUsina = (props: any) => {
    const { setTitlePage, handleGetDataUser } = useAuth();
    const user = handleGetDataUser();

    const isMasterOrAdmin = user.perfil === "Master" || user.perfil === "Admin";

    useEffect(() => {
        setTitlePage("Faturamento - Faturas de Usinas");
    }, [setTitlePage]);

    const [data, setData] = useState<any[]>([]);
    const [pageSize, setPageSize] = useState(100);
    const [page, setPage] = useState(0);
    const [filters, setFilters] = useState(null);
    const [rowCount, setRowCount] = useState(0);
    const [isLoading, setLoading] = useState(false);
    const [openNew, setOpenNew] = useState(false);
    const [openLoad, setOpenLoad] = useState(false);
    const [buttonSelected, setButtonSelected] = useState<any[]>([]);
    const [exclusionLoading, setExclusionLoading] = useState(false);
    const [exclusionState, setExclusionState] = useState({ data: "", open: false });
    const [editState, setEditState] = useState({ open: false, id: "", quantidadeInjetada: "", cicloFaturamento: "" });
    const [usinaDataOptions, setUsinaDataOptions] = useState<IGenericResult[]>([]);
    const [concessionariaDataOptions, setConcessionariaDataOptions] = useState<IGenericResult[]>([]);
    const [disableButtonApprove, setDisableButtonApprove] = useState<number>(0);
    const [disableButtonFinalize, setDisableButtonFinalize] = useState<number>(0);
    const [finalizeState, setFinalizeState] = useState({ data: "", open: false });

    const history = useHistory();

    const [sortModel, setSortModel] = useState<GridSortModel>([
        {
            field: "",
            sort: "" as GridSortDirection,
        },
    ]);

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useForm({
        defaultValues: {
            usinaID: 0,
            cicloFaturamento: null,
            statusFaturaUsina: "",
            dataEmissao: null,
            concessionariaID: 0,
        },
    });

    const [approveState, setApproveState] = useState({
        open: false,
        idFaturaUsina: "",
        idUsina: "",
        nomeUsina: "",
    });

    const actionColumns = useMemo(
        () => [
            {
                headerName: "Operações",
                field: "operations",
                type: "actions",
                minWidth: 270,
                flex: 1,
                hide: false,
                getActions: (params: { id: GridRowId; row: GridRowModel }) => [
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Faturas Previstas">
                                <Description />
                            </Tooltip>
                        }
                        label="Faturas Previstas"
                        onClick={() => onClickFaturasPrevistas(params.row.usinaID, params.row.cicloFaturamento)}
                        disabled={params.row.statusFaturaUsina === "Aguardando Aprovação"}
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Relatório">
                                <Grading />
                            </Tooltip>
                        }
                        label="Relatório"
                        onClick={() => onClickRelatorio(params.row.usinaID)}
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Download">
                                <Download />
                            </Tooltip>
                        }
                        label="Baixar"
                        onClick={() => {
                            const bucket = process.env.REACT_APP_S3_BUCKET_FATURAS_USINA || "";
                            s3download(bucket, `${params.row.nomeUsina}/${params.id.toString()}.pdf`);
                        }}
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Aprovar">
                                <CheckCircle />
                            </Tooltip>
                        }
                        label="Aprovar"
                        onClick={() => {
                            setDisableButtonApprove(Number(params.id));
                            setApproveState({
                                open: true,
                                idFaturaUsina: params.id.toString(),
                                idUsina: params.row.usinaID,
                                nomeUsina: params.row.nomeUsina,
                            });
                        }}
                        disabled={
                            params.row.statusFaturaUsina !== "Aguardando Aprovação" ||
                            params.id === disableButtonApprove
                        }
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Editar">
                                <Edit />
                            </Tooltip>
                        }
                        label="Editar"
                        onClick={() =>
                            setEditState({
                                open: true,
                                id: params.id.toString(),
                                quantidadeInjetada: params.row.quantidadeInjetada,
                                cicloFaturamento: params.row.cicloFaturamento,
                            })
                        }
                        disabled={params.row.statusFaturaUsina !== "Aguardando Aprovação"}
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Excluir">
                                <Delete />
                            </Tooltip>
                        }
                        label="Excluir"
                        onClick={() => setExclusionState({ data: params.id.toString(), open: true })}
                        disabled={
                            !(
                                user.perfil === "Admin" ||
                                (user.perfil === "Master" && params.row.statusFaturaUsina !== "Finalizado")
                            )
                        }
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Finalizar">
                                <Task />
                            </Tooltip>
                        }
                        label="Finalizar"
                        onClick={() => {
                            setDisableButtonFinalize(Number(params.id));
                            setFinalizeState({ data: params.id.toString(), open: true });
                        }}
                        disabled={
                            params.row.statusFaturaUsina === "Finalizado" ||
                            params.row.quantidadeInjetada !== "0,00" ||
                            !isMasterOrAdmin ||
                            params.id === disableButtonFinalize
                        }
                    />,
                ],
            },
        ],
        [disableButtonApprove, disableButtonFinalize, filters]
    );

    const columns = useMemo(
        () => [
            {
                headerName: "ID",
                field: "faturaUsinaID",
                type: "number",
                headerAlign: "left",
                identity: true,
                minWidth: 70,
            },
            {
                headerName: "Ciclo",
                field: "cicloFaturamento",
                type: "string",
                minWidth: 80,
            },
            {
                headerName: "Usina",
                field: "nomeUsina",
                type: "string",
                minWidth: 270,
            },
            {
                headerName: "Leitura",
                field: "dataLeituraAtual",
                type: "date",
                minWidth: 100,
            },
            {
                headerName: "Emissão",
                field: "dataEmissao",
                type: "date",
                minWidth: 110,
            },
            {
                headerName: "Qtd Injetada",
                field: "quantidadeInjetada",
                type: "number",
                headerAlign: "left",
                minWidth: 140,
            },
            {
                headerName: "Saldo",
                field: "saldoAcumulado",
                type: "number",
                headerAlign: "left",
                minWidth: 140,
            },
            {
                headerName: "Vencimento",
                field: "dataVencimento",
                type: "date",
                minWidth: 110,
            },
            {
                headerName: "Concessionária",
                field: "nomeConcessionaria",
                type: "string",
                minWidth: 300,
            },
            {
                headerName: "Valor fatura (R$)",
                field: "valorFatura",
                type: "number",
                headerAlign: "left",
                minWidth: 150,
            },
            {
                headerName: "Status",
                field: "statusFaturaUsina",
                type: "string",
                minWidth: 220,
                flex: 1,
            },
            ...actionColumns,
        ],
        [actionColumns]
    );

    useEffect(() => {
        setUsinaData();
    }, []);

    const setUsinaData = async () => {
        serviceUsina
            .getUsinas()
            .then((result) => {
                setUsinaDataOptions(result?.data);
            })
            .catch(() => {
                setUsinaDataOptions([]);
            });
    };

    useEffect(() => {
        setConcessionariaData();
    }, []);

    const setConcessionariaData = async () => {
        serviceConcessionaria
            .getConcessionarias()
            .then((result) => {
                setConcessionariaDataOptions(result?.data);
            })
            .catch(() => {
                setConcessionariaDataOptions([]);
            });
    };

    const statusOptions = [
        { label: "Aguardando Aprovação", value: "Aguardando Aprovação" },
        { label: "Aprovado", value: "Aprovado" },
        { label: "Aguardando para Iniciar", value: "Aguardando Para Iniciar" },
        { label: "Aguardando para Finalizar", value: "Aguardando Para Finalizar" },
        { label: "Finalizado", value: "Finalizado" },
    ];

    const throwAsyncError = useThrowAsyncError();

    const getAllWithFilters = async (filters: any) => {
        setData([]);
        setLoading(true);

        const newFilters = {
            ...filters,
            dataEmissao:
                filters && filters.dataEmissao
                    ? filters.dataEmissao.length === 10
                        ? filters.dataEmissao
                        : format(filters?.dataEmissao, "dd/MM/yyyy")
                    : "",
        };

        serviceFaturaUsina
            .getWithFilter({
                ...newFilters,
                take: pageSize,
                currentPage: page + 1,
                sortExpression: sortModel[0]?.field ?? "",
                sortDirection: sortModel[0]?.sort ?? "",
            })
            .then((result) => {
                if (!result) {
                    throw new Error("Falha ao carregar os dados.");
                }
                setData(result.data.content);
                setRowCount(result.data.numberOfElements);
            })
            .catch((err) => {
                setData([]);
                setRowCount(0);
                throwAsyncError(err);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(
        () => {
            getAllWithFilters(filters);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [page, pageSize, sortModel]
    );

    const handleDelete = async () => {
        setExclusionLoading(true);

        serviceFaturaUsina
            .delete(exclusionState.data)
            .then((result) => {
                if (result) {
                    toast.success(messages.deleteSucess);
                }
            })
            .catch((err) => {
                toast.error(messages.deleteError, err);
            })
            .finally(() => {
                setExclusionLoading(false);
                setExclusionState({ data: "", open: false });
                getAllWithFilters(filters);
            });
    };

    const handleFinalize = async () => {
        serviceFaturaUsina
            .finalize(finalizeState.data)
            .then((result) => {
                if (result) {
                    toast.success("Fatura de Usina finalizada com sucesso!");
                }
            })
            .finally(() => {
                setFinalizeState({ data: "", open: false });
                getAllWithFilters(filters);
            });
    };

    const handleClickOpenNew = () => {
        setOpenNew(true);
    };

    const handleCloseNew = () => {
        setOpenNew(false);
    };

    const handleClickOpenLoad = () => {
        setOpenLoad(true);
    };

    const handleCancelLoad = () => {
        setOpenLoad(false);
    };

    const onSubmit = (values: any) => {
        const newFilters = {
            ...values,
            dataEmissao: values.dataEmissao
                ? values.dataEmissao.length === 10
                    ? values.dataEmissao
                    : format(values?.dataEmissao, "dd/MM/yyyy")
                : "",
            statusFaturaUsina: buttonSelected.join(","),
            cicloFaturamento: values.cicloFaturamento ? format(values.cicloFaturamento, "MM/yyyy") : "",
        };

        setFilters(newFilters);
        getAllWithFilters(newFilters);
    };

    const onClickFaturasPrevistas = (usinaID: any, cicloFaturamento: any) => {
        history.push("/faturamento/faturaprevista", {
            usinaID: usinaID,
            cicloFaturamento: cicloFaturamento,
            filterOld: filters,
            rotaAnterior: "/faturamento/faturausina",
        });
    };

    const onClickRelatorio = (usinaID: any) => {
        history.push({
            pathname: "/usinas/revisaocotas",
            state: { usinaID: usinaID },
        });
    };

    const onClear = () => {
        setButtonSelected([]);

        reset({
            usinaID: 0,
            cicloFaturamento: null,
            statusFaturaUsina: "",
            dataEmissao: null,
            concessionariaID: 0,
        });

        setFilters(null);
        getAllWithFilters(null);
        props = null;
    };

    const onSuccessAction = () => {
        getAllWithFilters(filters);
    };

    useEffect(() => {
        if (props && props.location && props.location.state) {
            setLoading(true);

            setTimeout(() => {
                if (props.location.state.statusFaturaUsina) {
                    const newArray = props.location.state.statusFaturaUsina
                        ? Array.isArray(props.location.state.statusFaturaUsina)
                            ? props.location.state.statusFaturaUsina
                            : props.location.state.statusFaturaUsina.split(",")
                        : "";

                    setButtonSelected(newArray);
                } else {
                    setButtonSelected([]);
                }

                reset({ ...props.location.state });
                setFilters(props.location.state);

                const newFilters = {
                    ...props.location.state,
                    cicloFaturamento: props.location.state.cicloFaturamento
                        ? format(props.location.state.cicloFaturamento, "MM/yyyy")
                        : "",
                };

                getAllWithFilters(newFilters);
            }, 1000);

            setLoading(false);
        }
    }, [props]);

    return (
        <Container>
            <Card>
                <CardContent>
                    <Box sx={{ mb: 2 }}>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Grid container spacing={2} display="flex" alignItems="center">
                                <Grid item xs={12} md={6}>
                                    <AutoComplete
                                        name="usinaID"
                                        label="Nome da usina"
                                        options={usinaDataOptions}
                                        control={control}
                                        error={errors}
                                        concatWithID={false}
                                    />
                                </Grid>

                                <Grid item xs={12} md={2}>
                                    <DatePickerMui
                                        name="dataEmissao"
                                        label="Emissão"
                                        control={control}
                                        error={errors}
                                        noDateForward
                                    />
                                </Grid>

                                <Grid item xs={12} md={2}>
                                    <Button
                                        style={{ marginTop: 16, marginBottom: 8 }}
                                        variant="contained"
                                        color="warning"
                                        startIcon={<Search />}
                                        disableElevation
                                        type="submit"
                                        fullWidth
                                        size="medium"
                                    >
                                        Pesquisar
                                    </Button>
                                </Grid>

                                <Grid item xs={12} md={2}>
                                    <Button
                                        style={{ marginTop: 16, marginBottom: 8 }}
                                        variant="contained"
                                        color="primary"
                                        startIcon={<AddCircle />}
                                        onClick={handleClickOpenNew}
                                        disableElevation
                                        fullWidth
                                        size="medium"
                                    >
                                        Novo
                                    </Button>
                                </Grid>
                            </Grid>

                            <Grid container spacing={2} display="flex" alignItems="center">
                                <Grid item xs={12} md={6}>
                                    <AutoComplete
                                        name="concessionariaID"
                                        label="Nome da concessionária"
                                        options={concessionariaDataOptions}
                                        control={control}
                                        error={errors}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <DatePickerMui
                                        name="cicloFaturamento"
                                        label="Ciclo"
                                        format="MM/yyyy"
                                        view={["month", "year"]}
                                        control={control}
                                        error={errors}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2} display="flex" alignItems="center">
                                    <Button
                                        style={{ marginTop: 16, marginBottom: 8 }}
                                        variant="outlined"
                                        color="warning"
                                        startIcon={<Clear />}
                                        onClick={() => onClear()}
                                        disableElevation
                                        fullWidth
                                        size="medium"
                                    >
                                        Limpar
                                    </Button>
                                </Grid>
                                <Grid item xs={12} md={2} display="flex" alignItems="center">
                                    <Button
                                        style={{ marginTop: 16, marginBottom: 8 }}
                                        variant="contained"
                                        color="primary"
                                        startIcon={<Upload />}
                                        onClick={handleClickOpenLoad}
                                        disableElevation
                                        fullWidth
                                        size="medium"
                                    >
                                        Carregar
                                    </Button>
                                </Grid>
                            </Grid>
                            <Grid container display="flex" alignItems="center">
                                <Grid item sx={{ mt: 2 }}>
                                    <Typography variant="subtitle2" color="#5B5B5F">
                                        Status:
                                        {statusOptions.map((item, index) => {
                                            return (
                                                <Button
                                                    key={index}
                                                    variant={
                                                        buttonSelected.includes(item.value) ? "contained" : "outlined"
                                                    }
                                                    color="warning"
                                                    size="small"
                                                    disableElevation
                                                    onClick={() => {
                                                        setButtonSelected((oldstate) => {
                                                            if (oldstate.includes(item.value)) {
                                                                return oldstate.filter((e) => e !== item.value);
                                                            } else {
                                                                return [...oldstate, item.value];
                                                            }
                                                        });
                                                    }}
                                                    style={{ margin: "0px 12px", minWidth: "120px", height: "33px" }}
                                                >
                                                    {item.label}
                                                </Button>
                                            );
                                        })}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </form>
                    </Box>

                    <Box sx={{ height: 450 }}>
                        <DataTable
                            columns={columns}
                            rows={data}
                            rowId={(row: GridRowModel) => row.faturaUsinaID}
                            rowCount={rowCount}
                            isLoading={isLoading}
                            onPageChange={(currentPage: number) => setPage(currentPage)}
                            onPageSizeChange={(currentPageSize: number) => setPageSize(currentPageSize)}
                            pageSize={pageSize}
                            onSortModelChange={(model: GridSortModel) => setSortModel(model)}
                        />
                    </Box>

                    <ConfirmationDialog
                        open={exclusionState?.open}
                        loading={exclusionLoading}
                        title={"Excluir"}
                        message={messages.deleteConfirmation}
                        cancelButtonText={"Não"}
                        confirmButtonText={"Sim"}
                        onClose={() => setExclusionState({ data: "", open: false })}
                        onCancel={() => setExclusionState({ data: "", open: false })}
                        onConfirm={() => {
                            handleDelete();
                        }}
                    />

                    <DialogNew
                        open={openNew}
                        onSuccess={() => onSuccessAction()}
                        onClose={() => {
                            handleCloseNew();
                        }}
                    />

                    <DialogLoad
                        open={openLoad}
                        onSuccess={() => onSuccessAction()}
                        onClose={() => {
                            handleCancelLoad();
                        }}
                    />

                    <DialogEdit
                        open={editState.open}
                        onSuccess={() => onSuccessAction()}
                        data={{
                            open: editState.open,
                            id: editState.id,
                            quantidadeInjetada: editState.quantidadeInjetada,
                            cicloFaturamento: editState.cicloFaturamento,
                        }}
                        onClose={() => {
                            setEditState({ open: false, id: "", quantidadeInjetada: "0,00", cicloFaturamento: "" });
                        }}
                    />

                    <DialogApprove
                        open={approveState.open}
                        onSuccess={() => {
                            onSuccessAction();
                            setDisableButtonApprove(0);
                        }}
                        data={{
                            open: approveState.open,
                            id: approveState.idFaturaUsina,
                            idUsina: approveState.idUsina,
                            nomeUsina: approveState.nomeUsina,
                        }}
                        onClose={() => {
                            setApproveState({ open: false, idFaturaUsina: "", idUsina: "", nomeUsina: "" });
                            setDisableButtonApprove(0);
                        }}
                    />

                    <ConfirmationDialog
                        open={finalizeState?.open}
                        title={"Finalizar"}
                        message={"Deseja realmente finalizar essa Fatura de Usina?"}
                        cancelButtonText={"Não"}
                        confirmButtonText={"Sim"}
                        onClose={() => {
                            setFinalizeState({ data: "", open: false });
                            setDisableButtonFinalize(0);
                        }}
                        onCancel={() => {
                            setFinalizeState({ data: "", open: false });
                            setDisableButtonFinalize(0);
                        }}
                        onConfirm={() => {
                            handleFinalize();
                            setFinalizeState({ data: "", open: false });
                            setDisableButtonFinalize(0);
                        }}
                    />
                </CardContent>
            </Card>
        </Container>
    );
};

export default FaturaUsina;
